import * as colors from "./colors";
import * as fontWeights from "./fontWeights";
import { StyleSheet } from "aphrodite";

export default StyleSheet.create({
	container: {
		padding: 24,
		flex: 1,
	},
	header: {
		color: colors.docketLightishBlue,
		fontSize: 36,
		textAlign: "center",
		marginBottom: 0,
		marginTop: 6,
	},
	validationMessage: {
		color: colors.docketRed,
		fontSize: 14,
		fontWeight: fontWeights.LIGHT,
		textAlign: "center",
		marginBottom: 11,
		marginTop: 23,
		visibility: "hidden",
	},
	visible: {
		visibility: "visible",
	},
});
